// src/pages/ProductList.js
import React, { useEffect, useState } from 'react';
import { fetchProducts } from '../services/api';
import { useCart } from '../context/CartContext';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const { dispatch } = useCart();

  useEffect(() => {
    fetchProducts().then((response) => setProducts(response.data));
  }, []);

  const addToCart = (product) => {
    dispatch({
      type: 'ADD_TO_CART',
      payload: { ...product, id: product._id, quantity: 1 },
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">Catalogue Produits</h2>
        <p className="text-slate-500 text-sm mt-1">Découvrez notre sélection de produits technologiques.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => {
          const isOutOfStock = product.stock <= 0;
          const isLowStock = product.stock > 0 && product.stock <= 5;

          return (
            <div key={product._id} className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between h-full">
              <div>
                <div className="flex justify-between items-start mb-2 gap-4">
                  <h3 className="text-lg font-semibold text-slate-800 leading-tight">{product.name}</h3>
                  <span className="text-lg font-bold text-indigo-600 shrink-0">{product.price} €</span>
                </div>
                <p className="text-slate-500 text-sm mb-4 line-clamp-3">{product.description}</p>
              </div>

              <div className="space-y-4 mt-auto">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-slate-400">Disponibilité :</span>
                  {isOutOfStock ? (
                    <span className="bg-rose-50 text-rose-600 px-2.5 py-0.5 rounded-full font-semibold border border-rose-100">
                      Rupture de stock
                    </span>
                  ) : isLowStock ? (
                    <span className="bg-amber-50 text-amber-600 px-2.5 py-0.5 rounded-full font-semibold border border-amber-100">
                      Stock limité ({product.stock})
                    </span>
                  ) : (
                    <span className="bg-emerald-50 text-emerald-600 px-2.5 py-0.5 rounded-full font-semibold border border-emerald-100">
                      En stock ({product.stock})
                    </span>
                  )}
                </div>

                <button
                  onClick={() => addToCart(product)}
                  disabled={isOutOfStock}
                  className={`w-full py-2.5 px-4 rounded-lg font-medium text-sm transition-colors text-center block ${
                    isOutOfStock
                      ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                      : 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-sm shadow-indigo-600/10'
                  }`}
                >
                  {isOutOfStock ? 'Épuisé' : 'Ajouter au panier'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductList;
